import React from "react";
import { useTranslation } from "react-i18next";

import { api } from "~/lib/api";
import { Button } from "../ui/button";

export function EnableMollieIntegration() {
  const { t } = useTranslation("common");
  const { mutate: connect } = api.mollie.connectAuth.useMutation({
    onSuccess(result) {
      if (result) {
        window.location.href = result;
      }
    },
  });
  return (
    <div className="flex flex-col gap-6">
      <p>{t("Integrations.Mollie.description")}</p>
      <Button
        onClick={() => {
          connect(true);
        }}
        variant="success"
        size="lg"
        className="text-xl"
      >
        Connect now
      </Button>
    </div>
  );
}

export function DisableMollieIntegration() {
  const { t } = useTranslation("common");
  return (
    <div className="flex flex-col gap-6">
      <p>{t("Integrations.GoogleReserve.disable_description")}</p>
    </div>
  );
}
